module.exports = __webpack_public_path__ + "static/media/wire5.f06df222.jpeg";